import React from 'react';
import styles from './error-field.module.scss';

interface IErrorField {
  message?: string | any,
}

function ErrorField({ message = '' }: IErrorField): JSX.Element {
  return (
    <div className={styles['errors-fields']}>
      <p>{message}</p>
    </div>
  );
}

export default ErrorField;
